const GetCascadeChildrenOrderedApi = async (planId, performanceCycle, positionId) => {
  try {
    // 🔑 FIXED: Add cache-busting timestamp to ensure fresh data
    const timestamp = Date.now();
    const apiUrl = `${process.env.REACT_APP_API_URL}v1/plans/${planId}/cascade-children-ordered?performanceCycle=${performanceCycle}&positionId=${positionId}&_t=${timestamp}`;
    
    const token = 'Bearer ' + localStorage.getItem('authToken');
    const response = await fetch(apiUrl, {
      method: 'GET',
      headers: {
        Authorization: token,
        'Cache-Control': 'no-cache', // 🔑 FIXED: Prevent caching
        'Pragma': 'no-cache'
      },
    });

    const data = await response.json();
    
    return data;
  } catch (error) {
    console.error('Error fetching cascade children:', error);
    return { success: false, error: error.message };
  }
};

export default GetCascadeChildrenOrderedApi;